'use client';

import styles from '@/app/(pages)/home/components/new/News/BtnBlock.module.css';
import { ArrowRight } from 'lucide-react';
import React, { useState } from 'react';
import Link from 'next/link';
import { NewsType } from '@/lib/type/type';
import { slugify } from '@/lib/utils/slugify';

interface Props {
    newsItem: NewsType;
}

export const BtnBlock = ({ newsItem }: Props) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const slug = slugify(newsItem.title);
    const href = `/news/${slug}-${newsItem.message_id}`;

    return (
        <>
            <Link href={href}>
                <button className={styles.cardDetailsLink} onClick={() => setIsOpen(!isOpen)}>
                    Подробнее <ArrowRight size={16} />
                </button>
            </Link>
        </>
    );
};
